import NoPrint from './NoPrint'
export default NoPrint